module.exports = __webpack_public_path__ + "static/media/large-event.8ecb8a3d.png";